module.exports = __webpack_public_path__ + "img/st.67c4c6ba.png";